<template>
  <div class="brief-confirmation">
    <h3 class="font-md mb-6 lh-tight">
      Thanks for your brief. The APS booking team is reviewing your request and will be back to you within 24 hours.<br><br>
      If you have an urgent query or need to speak to one of the team, please contact <a class="wt-bold" href="mailto:bookings@aperfectspace.com">bookings@aperfectspace.com</a>, you can call Kate on 0419 546 361 or click on the chatbot
    </h3>
    <a
      v-if="$store.getters['user/account']"
      class="button primary interactive"
      @click="goToDashboard"
    >
      Take me to my dashboard
    </a>
  </div>
</template>

<script>
import BaseModal from "../Base";

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  methods: {
    goToDashboard() {
      this.$store.commit('findspace/navigateToSubpage', { page: 'briefs', subpage: 'home' })
      this.$emit("cancel");
    },
  },
};
</script>
